import { useEffect, useState } from 'react';
import { Api } from '@infra/api';
import { Units } from '@domain/models';
import { Modal } from '../components/Modal';
import { DataTable } from '../components/DataTable';

const empty: Units = { unit_code: '', unit_name: '' };

export function UnitsPage() {
  const [items, setItems] = useState<Units[]>([]);
  const [form, setForm] = useState<Units>({ ...empty });
  const [selected, setSelected] = useState<Units & { id: number } | null>(null);

  useEffect(() => {
    Api.listUnits().then(setItems).catch(console.error);
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const created = await Api.createUnit(form);
    setItems([created, ...items]);
    setForm({ ...empty });
  }

  async function saveSelected() {
    if (!selected || selected.id == null) return;
    const updated = await Api.updateUnit(selected.id, { unit_code: selected.unit_code, unit_name: selected.unit_name });
    setItems(items.map(u => (u.id === updated.id ? updated : u)));
    setSelected(null);
  }

  return (
    <div>
      <div className="toolbar">
        <div className="title"><h2 style={{margin:0}}>Единицы измерения</h2></div>
      </div>
      <div className="row">
        <form className="card" onSubmit={submit} style={{maxWidth:520}}>
          <h3 style={{marginTop:0}}>Новая единица</h3>
          <label>Код</label>
          <input value={form.unit_code} onChange={e=>setForm({...form, unit_code:e.target.value})} required />
          <label>Название</label>
          <input value={form.unit_name} onChange={e=>setForm({...form, unit_name:e.target.value})} required />
          <div style={{marginTop:12}}>
            <button>Создать</button>
          </div>
        </form>

        <div style={{flex:2}}>
          <DataTable
            data={items}
            title="Список"
            searchFields={['unit_code', 'unit_name']}
            searchPlaceholder="Поиск по коду, названию..."
            onRowClick={(item) => item.id != null && setSelected(item as Units & {id:number})}
            columns={[
              { key: 'unit_code', title: 'Код' },
              { key: 'unit_name', title: 'Название' }
            ]}
          />
        </div>
      </div>

      {selected && (
        <Modal title={`Единица: ${selected.unit_name}`} onClose={()=>setSelected(null)}>
          <div>
            <label>Код</label>
            <input value={selected.unit_code} onChange={e=>setSelected({...selected!, unit_code:e.target.value})} />
            <label>Название</label>
            <input value={selected.unit_name} onChange={e=>setSelected({...selected!, unit_name:e.target.value})} />
            <div style={{marginTop:12, display:'flex', gap:8}}>
              <button onClick={saveSelected}>Сохранить</button>
              <button className="secondary" onClick={()=>setSelected(null)}>Отмена</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}


